
/**
 * The direction of the sort operation. It can be either ascending (ASC) or descending (DESC).
 * @export
 * @enum {string}
 */
export enum SearchDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}